import React from 'react'
import Box from '@mui/material/Box'
import CellBadge from '../CellBadge'
import { Typography } from '@mui/material'
import CustomTooltip from '../../../CustomTooltip'
import { grey } from '../../../../colors'

interface MultiBadgeProps {
  list: string[]
  maxVisible?: number
  disabled?: boolean
}

const MultiBadge: React.FC<MultiBadgeProps> = ({ list, maxVisible = 3, disabled = false }) => {
  const visibleBadge = list.slice(0, maxVisible)
  const remainingBadges = list.slice(maxVisible)

  const Title = (): JSX.Element => {
    return (
      <Box display={'flex'} gap={1} flexWrap={'wrap'}>
        {remainingBadges?.map((item: string, index: number) => {
          const isLast = index === remainingBadges.length - 1
          return (
            <React.Fragment key={index} >
              <Typography fontWeight={600} color={grey[0]} fontSize={'12px'}>
                {isLast ? item : `${item},`}
              </Typography>
            </React.Fragment>
          )
        })
        }
      </Box >
    )
  }

  return (
    <Box display="flex" alignItems={'center'} flexWrap={'wrap'} gap={2}>
      {visibleBadge?.map((item: string, index: number) => (
        <CellBadge label={item} key={index} disabled={disabled} />
      ))}

      {list?.length > maxVisible && (
        <CustomTooltip
          title={<Title />}
        >
          <CellBadge label={`+${list?.length - maxVisible}`} disabled={disabled} />
        </CustomTooltip>
      )}

    </Box>
  )
}

export default MultiBadge
